
    import validation from '@/validation';
    import { computed, defineComponent, ref, toRef, watch } from 'vue';

    export default defineComponent({
        emits: ['update:modelValue'],
        props: {
            modelValue: { default: '' },
            id: { type: String, required: true },
            icon: { type: String, default: undefined },
            minLength: { type: Number, default: 0 },
            maxLength: { type: Number, default: -1 },
            min: { type: Number, default: undefined },
            max: { type: Number, default: undefined },
            required: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            type: { type: String, default: 'text' },
            step: { type: Number, default: 0 },
            placeholder: { type: String, default: '' },
        },
        setup(props, { emit }) {
            const { id, minLength, maxLength, required, type } = props;
            const modelValue = toRef(props, 'modelValue');

            const showError = ref(false);
            const value = computed({
                get() {
                    return modelValue.value;
                },
                set(value: any) {
                    if (type === 'number' && value !== '' && value !== null && value !== undefined) {
                        const numVal = Number(value);
                        if (props.min !== undefined && numVal < props.min) {
                            value = props.min;
                        }
                        if (props.max !== undefined && numVal > props.max) {
                            value = props.max;
                        }
                    }
                    emit('update:modelValue', value);
                },
            });
            const errors = computed(() => validation.get(id));
            watch(value, (newValue, oldValue) => {
                validation.clear(id);
                if (typeof newValue !== 'string') return;
                // Skip re-validating when the field is cleared (form reset after submit)
                if (newValue.length === 0 && typeof oldValue === 'string' && oldValue.length > 0) {
                    return;
                }
                validation.base(id, newValue, minLength, maxLength, required);
                if (type == 'email') {
                    validation.email(id, newValue);
                }
            });
            return { showError, value, errors };
        },
    });
